import type { Millimeters } from './types.js';
import type { ComponentInstance } from './component.js';
import type { SolderJoint } from './solder-joint.js';
import type { ComponentDef } from '../library/component-def.js';
import type { Wire } from './wire.js';

export const PROJECT_FORMAT_VERSION = 1 as const;

export interface ProjectMetadata {
  name: string;
  created_at: string; // ISO 8601
  modified_at: string; // ISO 8601
  author?: string;
  description?: string;
}

export interface CanvasSettings {
  units: 'mm';
  background_color?: string;
  /** Cuadrícula visual opcional (no en el MVP: fondo blanco sin rejilla). */
  grid?: {
    visible: boolean;
    spacing_mm: Millimeters;
  };
}

export interface Project {
  format_version: typeof PROJECT_FORMAT_VERSION;
  metadata: ProjectMetadata;
  canvas: CanvasSettings;
  components: ComponentInstance[];
  solder_joints: SolderJoint[];
  /** Cables / hilos de conexión sueltos en el lienzo. */
  wires?: Wire[];
  /**
   * Definiciones custom del usuario embebidas para que el proyecto
   * sea autoportante cuando la biblioteca externa no baste.
   */
  embedded_component_defs?: ComponentDef[];
}

export function createEmptyProject(name = 'Untitled'): Project {
  const now = new Date().toISOString();
  return {
    format_version: PROJECT_FORMAT_VERSION,
    metadata: {
      name,
      created_at: now,
      modified_at: now,
    },
    canvas: {
      units: 'mm',
      background_color: '#ffffff',
    },
    components: [],
    solder_joints: [],
  };
}
